import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { getQueryKey } from '@/feature/utils';
import { RoleType } from '@feature/security';

import { LoginRequest } from './LoginTypes';
import * as api from './SecurityApi';

const securityKey = getQueryKey('security');

export function useLogin() {
  const queryClient = useQueryClient();
  return useMutation<unknown, AxiosError, LoginRequest>({
    mutationFn: (payload: LoginRequest) => api.login(payload),
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: securityKey.root(),
      });
    },
  });
}

export function useLogout() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => api.logout(),
    onSuccess: () => queryClient.resetQueries(),
  });
}

export function getCurrentUserOptions() {
  return {
    queryKey: securityKey.as(['login']),
    queryFn: () => api.getCurrentUser(),
  };
}

export function useCurrentUserQuery() {
  return useQuery(getCurrentUserOptions());
}

export function useChangeCurrentRole() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (roleType: RoleType) => api.changeCurrentRole(roleType),
    // invalidate all queries on role change
    onSuccess: () => {
      return queryClient.resetQueries();
    },
  });
}
